<!--
 * @FileDescription: 图片模板（注释描述）
 * @Author:xy（作者）
 * @Date: 2020-04-15（时间）
 * @LastEditors: xy（最后更新人）
 * @LastEditTime: 2020-04-15（最后更新时间）
 -->
<template>
  <div class="picture">
      <div v-if="!isEmpty(imgUrl)" class="img-upload">
          <div  class="picture-img">
              <viewer :images="imgs">
                  <img  :src="imgUrl" alt="图片"/>
              </viewer>
              <div class="picture-img-delete">
                  <a-icon type="delete" class="picture-delete" @click="onDelete"  />
              </div>
          </div>
          <div class="img-title" @click="onDelete">重新上传</div>
      </div>

      <template v-else>
          <div  class="picture-left">
              <input type="file" id="input" ref="thumbnail" accept="image/*" @change="onImage"/>
              <a-icon :type="loading ? 'loading' : 'plus'" />
              <div class="ant-upload-text">
                  选择图片
              </div>
          </div>
          <slot name="note">
              <div class="picture-right" v-show="isRemarks">仅支持PNG、JPG等格式</div>
          </slot>
      </template>
  </div>
</template>
<script>
import 'viewerjs/dist/viewer.css'
import Viewer from "v-viewer/src/component.vue"
import {uploadFile} from "@/utils/api";
export default {
    props:{
        isRemarks:{
            type:Boolean,
            default:true
        },
        isMore:{
           type: Boolean,
            default:true
        },
        imgUrlProp:{
            type:Object,
            default:()=>{}
        },

    },
    data() {
        return {
            imgUrl:'',
            id:'',
            imgs:[],
            loading:false,
        }
    },
    methods: {
        /**
        * @description: 此为方法注释（方法描述）
        * @param {参数类型} 参数名称
        * @return void
        */
        onImage(){
            this.imgs = []
            let imageFile = this.$refs.thumbnail.files[0]
            $('#input').val('')
            var imgStr = /\.(jpg|jpeg|png|bmp|BMP|JPG|PNG|JPEG|gif)$/;
            if (!this.isEmpty(imageFile) && imgStr.test(imageFile.name)) {
                if (imageFile.size >  1024 * 1024) {
                    this.$message.warn('图片大于1兆,请重试')
                    return;
                }
                var form = new FormData()
                form.append("file",imageFile,imageFile.name)
                form.append("type","store")
                uploadFile(form,{
                    'Content-Type':'multipart/form-data'
                }).then((res)=>{
                    if(res.success){
                        this.imgUrl = res.result.resource_url
                        this.id = res.result.id
                        this.imgs.push(res.result.resource_url)
                        this.$emit('onChangeImg',res.result.id)
                        console.log(this.imgUrl)
                    }
                })
            }else{
                this.$message.warn('请检查图片格式')
            }
        },
        onDelete(){
            this.imgUrl = ''
            this.id = ''
            this.$emit('onChangeImg',this.id)

        }
    },
    components:{
        Viewer

    },
    watch:{
        imgUrlProp: {
            handler(newValue, oldValue) {
                if(!this.isEmpty(newValue)){
                    this.imgs = []
                    this.imgUrl = newValue.url
                    this.id = newValue.id
                    this.imgs.push(newValue.url)
                }
            },
            deep: true
        }

    },
    mounted(){
    },
    created(){

    }
}
</script>
<style lang="scss" scoped>
  .picture{
      display: flex;
      align-items: center;
      .img-upload{
          display: flex;
          align-items: center;
          .img-title{
              cursor: pointer;
              color: #387BFC;
              margin-left: 10px;
          }
      }
  }
    .picture-left{
        cursor: pointer;
        width:84px;
        height:84px;
        background:rgba(255,255,255,1);
        border:1px dashed #DDDDDD;
        border-radius:2px;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        &:hover{
            border-color: var(--co);
            .anticon-plus{
                color: var(--co) !important;
            }
            .ant-upload-text{
                color: var(--co);
            }
        }
        .anticon-plus{
            font-size: 23px;
            color: #DDDDDD;
        }

        input{
            position: absolute;
            top: 0;
            left: 0;
            width: 100px;
            height: 100px;
            display: inline-block;
            opacity: 0;
        }
        img{
            width: 26px;
            margin-bottom: 14px;
        }
        .ant-upload-text{
            line-height: 15px;
            color: #AAAAAA;
            font-size: 14px;
            margin-top: 5px;
        }

    }

    .picture-right{
        color:#FD5621;
        font-size: 14px;
        padding-left: 20px;
    }
    .picture-img{
        width: 84px;
        height: 84px;
        position: relative;
        &:hover{
            .picture-img-delete{
                opacity: 1;
            }
        }
        img{
            width: 84px;
            height: 84px;
            object-fit: cover;
        }
        .picture-img-delete{
            opacity: 0;
            position: absolute;
            width: 100%;
            height: 20px;
            background:rgba(0,0,0,0.3);
            bottom: 0;
            left: 0;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            .picture-delete{
                color: #fff;
                cursor: pointer;
            }
        }
    }
</style>
